import React from 'react';
import { ContactValidationProvider } from './ContactValidationContext/ContactValidationContext';
import { PropertyValidationProvider } from './PropertyValidationContext/PropertyValidationContext';
import { UnitValidationProvider } from './UnitValidationContext/UnitValidationContext';
import DisabledLookupContextProvider from './DisabledLookupContext';
import LeaseJourneyContextProvider from '../Views/Home/LeaseTransactionJourney/context/LeaseJourneyContext';

const ContextProvider = ({ children }) => {
  return (
    <ContactValidationProvider>
      <PropertyValidationProvider>
        <DisabledLookupContextProvider>
          <LeaseJourneyContextProvider>
            <UnitValidationProvider>{children}</UnitValidationProvider>
          </LeaseJourneyContextProvider>
        </DisabledLookupContextProvider>
      </PropertyValidationProvider>
    </ContactValidationProvider>
  );
};

export default ContextProvider;
